module.exports = __webpack_public_path__ + "static/media/HiiT Plc.c62ccedd.png";